<template>
  <div v-if="cardModels != null" id="show-card-model-card">
    <v-card class="mt-3">
      <v-card-title>
        Modèles de cartes <v-spacer></v-spacer>
        <v-btn color="primary" icon @click.stop="createCardModelDialog = true">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <create-card-model-dialog
          :partner="partner"
          :open.sync="createCardModelDialog"
          v-if="createCardModelDialog"
        ></create-card-model-dialog>
      </v-card-title>
      <v-card-text>
        <v-data-table
          v-if="cardModels.length > 0"
          :headers="headers"
          :items="cardModels"
          :items-per-page="10"
          dense
        >
          <template v-slot:item.actions="{ item }">
            <v-btn icon @click.stop="openEditModal(item)">
              <v-icon>mdi-square-edit-outline</v-icon>
            </v-btn>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  small
                  @click="deleteCardModel(item, partner)"
                  ><v-icon>mdi-delete</v-icon></v-btn
                ></template
              >
              <span>Supprimer le modèle de carte</span>
            </v-tooltip>
          </template>
          <template #[`item.duration`]="{ item }">
            {{ libelleDuration(item.duration) }}
          </template>
        </v-data-table>
        <edit-card-model-dialog
          :partner="partner"
          :card-model="editedItem"
          :open.sync="editCardModelDialog"
          v-if="editCardModelDialog"
        ></edit-card-model-dialog>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { onMounted, toRefs, ref } from "@vue/composition-api";
import { useCardModel } from "@/composables/card-model";
import CreateCardModelDialog from "@/components/CardModel/CreateCardModelDialog";
import EditCardModelDialog from "@/components/CardModel/EditCardModelDialog";
import { date } from "@/composables/date";

export default {
  components: { EditCardModelDialog, CreateCardModelDialog },
  props: {
    partner: Object,
  },
  setup(props) {
    /* Import des API */
    const {
      cardModels,
      listCardModels,
      deleteCardModel,
      cardModelData,
    } = useCardModel();
    const { libelleDuration } = date();

    /* Variables */
    const editedItem = ref({});

    /* Méthodes */
    const openEditModal = function (item) {
      editedItem.value = { ...item };
      cardModelData.editCardModelDialog = true;
    };

    /* Cycle de vie */
    onMounted(() => {
      listCardModels(props.partner.id);
    });

    return {
      cardModels,
      headers: [
        { text: "Action", value: "actions" },
        { text: "Description", value: "description" },
        { text: "Durée", value: "duration" },
        { text: "Origine", value: "cardOrigin.description" },
        { text: "Type", value: "cardType.description" },
        {
          text: "Nb sessions max",
          value: "simultaneousSessionsNum",
          width: "50px",
        },
      ],
      deleteCardModel,
      ...toRefs(cardModelData),
      openEditModal,
      editedItem,
      libelleDuration,
    };
  },
};
</script>
